<template>
    <div class="form-input-text" :class="{'form-input-text--is-expanded': isExpanded}">
      <input ref="input" type="text" :name="name"
         :value="valueInternal"
        @focus="isFocused = true"
        @blur="isFocused = false"
        @input="$emit('input', $event.target.value)"

      >
      <div ref="bottom-line" class="bottom-line">
        <div class="before"></div>
      </div>
      <div class="placeholder h6">{{placeholder}}</div>
    </div>
</template>

<script>

    //import comp from '@/path/to/comp.vue';    //от папки src указанной в webpack
  export default {
    components: {
    },
    //еще нужно свойство type, чтобы на мобилах правильные клавиатуры вываливались
    props: {
      placeholder: {
        type: String,
        default: null
      },
      name: String,
      value: String,
    },
    data(){
      return {
        isFocused: false,
        isMounted: false,
      }
    },
    computed: {
      valueInternal() {return this.value},
      valueInternal: {
        get(){
          return this.value;
        },
        set(newVal){
          this.$emit('input', newVal)
        }
      },
      isExpanded(){
        if(!this.isMounted) return;
        return this.isFocused || this.value;
      },
    },
    methods: {
    },
    mounted(){
      this.isMounted = true;
    }

  }
</script>
<style scoped lang="scss">
    @import 'src/scss/vars';    //от папки со сборкой
    .form-input-text {
      //отступ с учетом выезда плейсхолдера вверх
      --place-for-top-placeholder: calc( 24 * var(--px));


      position: relative;
      padding-top: var(--place-for-top-placeholder);
      input {
        font-family: 'din-display', sans-serif;
        width: 100%;
        height:calc( var(--sizeCell) * 3);
        padding-left:var(--sizeCell);
        padding-right:var(--sizeCell);
        border: none;
        outline: none;
        color: white;
        background-color: $clrBgDarkLess;
      }
      .bottom-line {
        height: calc( 2 * var(--px));
        background-color: white;
        position: relative;
        overflow: hidden; //fix for Edge
        transition: background-color $timeShort;
        .before {
          content: '';

          position: absolute;

          // в  edge почему-то before иногда на 1px меньше чем его контейнер
          // так не работает
          //height: calc(2 * var(--px));
          //и так тоже не работает
          top:0;
          bottom:0;
          //end
          width: 0;
          background-color: $clrAcc;
          transition: width $timeMed, background-color $timeShort;
          left: 50%;
          transform: translate(-50%, 0px);

        }
      }
      .placeholder {
        position: absolute;
        /*outline: 1px solid darkred;*/
        top: calc( 14 * var(--px) + var(--place-for-top-placeholder));
        left:var(--sizeCell);
        transition: all $timeShort;
        pointer-events: none;
      }
    }
    .form-input-text.form-input-text--is-expanded {
      .placeholder {
        top: calc( -20 * var(--px)  + var(--place-for-top-placeholder));
        font-size: calc( 15 * var(--px));
        left: 0;
      }
      .bottom-line {
        .before {
          width: calc(100% + 1px);
        }
      }
    }
    .form-input-text.form-input-text--has-error {
      .bottom-line {
        background-color: $clrErr;
        .before {
          background-color: $clrErr;
        }
      }
    }
</style>



// WEBPACK FOOTER //
// src/components/form-input-text.vue